import Cereali from "./img/Cereali";
import Crostacei from "./img/Crostacei";
import Uova from "./img/Uova";
import Pesce from "./img/Pesce";
import Arachidi from "./img/Arachidi";
import Soia from "./img/Soia";
import Latte from "./img/Latte";
import FruttaGuscio from "./img/FruttaGuscio";
import Sedano from "./img/Sedano";
import Senape from "./img/Senape";
import SemiSesamo from "./img/SemiSesamo";
import AnidrideSolforosaSolfiti from "./img/AnidrideSolforosaSolfiti";
import Lupini from "./img/Lupini";
import Molluschi from "./img/Molluschi";

const ICONS = {
	1: Cereali,
	2: Crostacei,
	3: Uova,
	4: Pesce,
	5: Arachidi,
	6: Soia,
	7: Latte,
	8: FruttaGuscio,
	9: Sedano,
	10: Senape,
	11: SemiSesamo,
	12: AnidrideSolforosaSolfiti,
	13: Lupini,
	14: Molluschi,
};

export function getAllergenLabel(allergen, lang = "it") {
	if (!allergen) return "";
	if (allergen.translations?.[lang]?.name) return allergen.translations[lang].name;
	if (typeof allergen.translations?.[lang] === "string" && allergen.translations[lang])
		return allergen.translations[lang];
	return allergen.name || "";
}

export function AllergenIcon({ allergen, color = "#000" }) {
	const Icon = ICONS[allergen?.id];
	return (
		<span className="allergen-icon" title={getAllergenLabel(allergen)}>
			{Icon && <Icon color={color} />}
		</span>
	);
}

// Elenco allergeni: solo icone (iconsOnly) oppure icona e nome
export default function Allergens({ allergens = [], iconsOnly = false }) {
	return (
		<div className={"allergens" + (iconsOnly ? " icons-only" : "")}>
			{allergens.map((allergen, i) =>
				iconsOnly ? (
					<AllergenIcon key={i} allergen={allergen} />
				) : (
					<div key={i} className="allergen-item">
						<AllergenIcon allergen={allergen} />
						<span>{getAllergenLabel(allergen)}</span>
					</div>
				)
			)}
		</div>
	);
}
